import React from "react";
import { Box } from "@mui/material";

export type SidebarDividerProps = {
  variant?: "thin" | "thick";
  width?: string;
};

export function SidebarDivider({
  variant = "thin",
  width = "40px",
}: SidebarDividerProps) {
  const getDividerStyles = () => {
    switch (variant) {
      case "thin":
        return {
          width,
          height: "1px",
          backgroundColor: "rgba(0, 0, 0, 0.12)",
        };
      case "thick":
        return {
          width: "80%",
          height: "1px",
          backgroundColor: "#E0E0E0",
        };
      default:
        return {
          width,
          height: "1px",
          backgroundColor: "rgba(0, 0, 0, 0.12)",
        };
    }
  };

  return <Box sx={getDividerStyles()} />;
}
